<template>
  <div class="home">
    <home-header/>
    <home-bnnaer/>
    <home-nav/>
    <home-content :data="contentList"/>
  </div>
</template>

<script>
import {wxShare} from "@/common/js/wx";
import {Tab, Tabs} from 'vant'
import HomeHeader from "@/views/home/HomeHeader";
import HomeBnnaer from "@/views/home/HomeBnnaer";
import HomeNav from "@/views/home/HomeNav";
import HomeContent from "@/views/home/HomeContent";

export default {
  name: 'Home',
  components: {
    HomeContent,
    HomeNav,
    HomeBnnaer,
    HomeHeader,
    Tab,
    Tabs,
  },
  data() {
    return {
      refreshNum: 1,
      videoList: [],
      contentList: [],
      active: '1',
      bannerData: [],
      RefreshNum: 0
    }
  },
  mounted() {
    wxShare('首页', '影像学院')
    this.getActiveteList()
    this.getActivity(1000)
    this.getActivity(2000)
  },
  methods: {
    getActiveteList(type) {
      this.getBannerList(type)
    },
    getBannerList(type) {
      this.$http.get(this.$api.banner.list).then(res => {
        // 轮播图
        let {code, data, message} = res
        if (code === 0) {
          this.bannerData = data
        } else {
          this.$nextTick(message)
        }
      })
    },
    getListId(id) {
      this.$router.push({path: '/contentDetail/' + id})
    },
    getActivity(type) {
      let params = {
        pageSize: 10,
        pageNum: 1,
        params: {
          type: type,
        }
      }
      this.$http.post(this.$api.activity.list, params).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.contentList = this.contentList.concat(data.content)
          this.activitySort()
        }
      })
    },
    activitySort() {
      this.contentList.sort((a, b) => {
        return a.shatime < b.shatime
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  background: #FFFFFF;
}
</style>
